/**
 * templatePickerDialogMessages.ts — the wire contract between the task pane and
 * the template-picker Office Dialog.
 *
 * The two run in separate windows and can only exchange JSON strings, so the
 * shapes live here rather than in either side: a change to one end that the
 * other doesn't follow is then a type error instead of a message silently
 * ignored at runtime.
 */

import type { TemplateCandidate, TemplateFitMode } from "./slideTransformTemplateApi";

/** Dialog → pane: "my handler is registered, send the candidates". */
export const TEMPLATE_PICKER_DIALOG_READY = "ready";

/** Pane → dialog (`Dialog.messageChild`). */
export type TemplatePickerDialogInbound = {
  readonly type: "candidates";
  readonly candidates: readonly TemplateCandidate[];
};

/** Dialog → pane (`Office.context.ui.messageParent`). */
export type TemplatePickerDialogOutbound =
  | { readonly type: typeof TEMPLATE_PICKER_DIALOG_READY }
  /** The user picked layouts and pressed Apply. `fitMode` is already resolved. */
  | {
      readonly type: "apply";
      readonly picks: readonly string[];
      readonly fitMode: TemplateFitMode;
    }
  /** "Use AI design instead" — abandon template mode for the freehand redesign. */
  | { readonly type: "use-ai" }
  /** Closed without choosing. */
  | { readonly type: "cancel" };

/** What the pane gets back once the dialog closes. */
export type TemplatePickerDialogResult =
  | { readonly kind: "apply"; readonly picks: readonly string[]; readonly fitMode: TemplateFitMode }
  | { readonly kind: "use-ai" }
  | { readonly kind: "cancel" };
